export class Tile {
  public color: string = '#002f6c';
  public glyph: string = 'fa fa-file';
  public caption: string = '';
  public help: string = '';
  public link: string = '';
  public id: number;
  public edit: boolean = false;

  constructor() {  }
}
